// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { Input, InputGroup } from "../../components/input";
import { withStore } from "../../store/withstore";
import { TranslationContext } from "../../translation";

const PurchasePrice = (props) => {
	const { store: { a, b }, storeAction } = props;
	const [valueA, setValueA] = useState(a.purchasePrice || "");
	const [valueB, setValueB] = useState(b.purchasePrice || "");
	const { translate, format } = useContext(TranslationContext);

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.purchaseprice.title"
			title="module.purchaseprice.query"
			valueA={format(valueA, true)}
			valueB={format(valueB, true)}
			continueEnabled={Boolean(valueA && valueB)}
			onContinue={() => storeAction.setPurchasePrice(valueA, valueB)}
			queryA={(
				<React.Fragment>
					<InputGroup prepend="EUR" style={{ maxWidth: "265px" }}>
						<Input
							type="number"
							placeholder={translate("module.purchaseprice.title")}
							value={valueA}
							onChange={(event) => setValueA(event.target.value)}
							tabIndex={(props.id === props.activeModule) ? 1 : -1}
						/>
					</InputGroup>
				</React.Fragment>
			)}
			queryB={(
				<React.Fragment>
					<InputGroup prepend="EUR" style={{ maxWidth: "265px" }}>
						<Input
							type="number"
							placeholder={translate("module.purchaseprice.title")}
							value={valueB}
							onChange={(event) => setValueB(event.target.value)}
							tabIndex={(props.id === props.activeModule) ? 2 : -1}
						/>
					</InputGroup>
				</React.Fragment>
			)}
		/>
	);
};

PurchasePrice.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string.isRequired,
	setActiveModule: PropTypes.func.isRequired
};

export default withStore(PurchasePrice);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/purchaseprice.js